                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    <template>
    <div class="col-md-12 col-lg-12 mobile_pr_15 packaging-options">
        <div class="white_box  shipping_fl_left">
            <h1 class="heading1">4. Packaging</h1>
            
            <!-- Packaging Options Form -->
            <div class="packaging-form mt-4">
                <!-- Question 1: Standard or Custom Box -->
                <div class="form-group mb-4">
                    <label class="question-label d-none">
                        Will Shipment be sent a standard or custom box?
                    </label>
                    <div class="radio-group">
                        <label class="radio-option">
                            <input
                                type="radio"
                                name="boxType"
                                value="standard"
                                v-model="packagingOptions.boxType"
                            />
                            <span class="radio-mark"></span>
                            <span class="radio-label">Standard</span>
                        </label>
                        <label class="radio-option d-none">
                            <input
                                type="radio"
                                name="boxType"
                                value="custom"
                                v-model="packagingOptions.boxType"
                            />
                            <span class="radio-mark"></span>
                            <span class="radio-label">Custom</span>
                        </label>
                    </div>
                </div>

                <!-- Question 2: Special Handling -->
                <div class="form-group mb-4 d-none">
                    <label class="question-label">
                        Will any items require special handling or packaging?
                    </label>
                    <div class="radio-group">
                        <label class="radio-option">
                            <input
                                type="radio"
                                name="specialHandling"
                                value="yes"
                                v-model="specialHandlingValue"
                            />
                            <span class="radio-mark"></span>
                            <span class="radio-label">Yes</span>
                        </label>
                        <label class="radio-option">
                            <input
                                type="radio"
                                name="specialHandling"
                                value="no"
                                v-model="specialHandlingValue"
                            />
                            <span class="radio-mark"></span>
                            <span class="radio-label">No</span>
                        </label>
                    </div>
                </div>

                <!-- Disclaimer -->
                <div class="disclaimer mt-4">
                    <p>
                        Disclaimer: Final Kitting Costs May Be More Or Less Than Shown, This Amount Should Be Considered An Estimate. Shipping Costs Can Vary Significantly Based On Location.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PackagingOptions",
    data() {
        return {
            packagingOptions: {
                boxType: 'standard',
                specialHandling: false
            },
            specialHandlingValue: 'no'
        };
    },
    computed: {
        isSplitShipment() {
            return this.$store.state.splitShipment && this.$store.state.splitShipment.isSplitShipment;
        }
    },
    watch: {
        specialHandlingValue(newVal) {
            this.packagingOptions.specialHandling = newVal === 'yes';
            this.savePackagingOptions();
        },
        'packagingOptions.boxType'() {
            this.savePackagingOptions();
        },
        'packagingOptions.specialHandling'() {
            this.savePackagingOptions();
        }
    },
    mounted() {
        // Load existing packaging options from Vuex
        const existingOptions = this.$store.state.splitShipment && this.$store.state.splitShipment.packagingOptions;
        if (existingOptions) {
            this.packagingOptions = {
                boxType: existingOptions.boxType || 'standard',
                specialHandling: existingOptions.specialHandling || false
            };
            this.specialHandlingValue = this.packagingOptions.specialHandling ? 'yes' : 'no';
        }
    },
    methods: {
        savePackagingOptions() {
            // Save to Vuex store
            this.$store.commit('splitShipment/setPackagingOptions', {
                boxType: this.packagingOptions.boxType,
                specialHandling: this.packagingOptions.specialHandling
            });
        }
    }
};
</script>

<style scoped>
.packaging-options {
    padding: 20px 0;
}

.packaging-options .white_box.shipping_fl_left {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
    padding: 24px 32px 24px 32px !important;
}

.packaging-options .heading1 {
    font-size: 24px;
    font-weight: 600;
    color: #121212;
    line-height: 1.3;
    margin-bottom: 0;
}
.packaging-form .form-group{
    border-bottom: 1px solid #B6B6B666;
    padding-bottom: 24px;
    margin-bottom: 0px;
}
.packaging-form {
    margin-top: 24px;
}

.packaging-options .form-group {
    margin-bottom: 32px;
}

.packaging-options .form-group:last-of-type {
    margin-bottom: 0;
}

.packaging-options .question-label {
    display: block;
    font-size: 16px;
    font-weight: 500;
    color: #121212;
    margin-bottom: 12px;
    line-height: 16px;
    position: relative;
}

.radio-group {
    display: flex;
    gap: 24px;
    align-items: center;
    flex-wrap: wrap;
}

.radio-option {
    position: relative;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    padding-left: 24px;
    font-size: 16px;
    color: #333;
    min-height: 24px;
    user-select: none;
}

.radio-option input[type="radio"] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    left: 0 !important;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    margin: 0;
    z-index: 3;
    pointer-events: auto;
}

.radio-mark {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    height: 20px;
    width: 20px;
    background-color: #fff;
    border: 2px solid #B6B6B6;
    border-radius: 50%;
    transition: border-color 0.2s;
    z-index: 1;
    pointer-events: none;
}

.radio-option:hover .radio-mark {
    border-color: #1D6CB5;
}

.radio-option input[type="radio"]:checked ~ .radio-mark {
    background-color: #fff;
    border-color: #1D6CB5;
}

.radio-option input[type="radio"]:checked ~ .radio-mark:after {
    content: "";
    position: absolute;
    display: block;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #1D6CB5;
}

.radio-label {
    margin-left: 8px;
    font-size: 16px;
    font-weight: 400;
    color: #121212;
    line-height: 1.5;
}

.disclaimer {
    font-size: 12px;
    color: #414141;
}

.disclaimer p,
.disclaimer .text-muted {
    margin: 0;
    color: #414141;
    font-size: 12px;
    line-height: 12px;
    font-style: italic;
}
</style>

<style>
/* Non-scoped styles to ensure radio buttons are clickable */
.packaging-options .radio-option input[type="radio"] {
    opacity: 0 !important;
    visibility: visible !important;
    position: absolute !important;
    left: 0 !important;
    width: 20px !important;
    height: 20px !important;
    cursor: pointer !important;
    z-index: 3 !important;
    pointer-events: auto !important;
}

.packaging-options .radio-mark {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    pointer-events: none !important;
}

.packaging-options .radio-option {
    pointer-events: auto !important;
}
</style>
